import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberCompetitionResults from '../../../components/documents/MemberCompetitionResults';

// Member-facing competition results view, reached via the "Results" button on the member's
// own "My Competitions" section (CompetitionEntryForm.tsx). Deliberately separate from the
// admin CompetitionResultEntries ranking tool (Exercises.tsx / Entries.tsx) - members only
// ever see this read-only leaderboard view, never the admin ranking/export screens.
const CompetitionResultsMyResults: React.FC = () => {
  const breadcrumbs = [
    { label: 'My Competitions', href: '/admin/competitionentries' },
    { label: 'Results', href: '#' },
  ];

  return (
    <AdminLayout
      activeMenuItem="/admin/competitionentries"
      breadcrumbs={breadcrumbs}
      allowedRoles={['User']}
    >
      <MemberCompetitionResults />
    </AdminLayout>
  );
};

export default CompetitionResultsMyResults;
